/* iceberg-ui */
import { Flex } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Typography } from '@mui/material';

/*  Shared  */
import { DataVisualCard } from 'application/Shared/Components/DataAPIVisualsCard';
import { FontSizes } from 'application/Shared/Constants';
import { TenantApp } from 'application/Shared/types/tenantApp';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

const counts = [
    'cloudActivityCount',
    'cloudLoginCount',
    'azureSignInCount',
    'googleSignInCount',
    'oktaSignInCount'
];

/**
 * Component that displays a card showing various user activity counts
 * @param {Object} props - Component props
 * @param {TenantApp} props.tenantApp - Tenant application data containing activity counts
 * @returns {JSX.Element} Card displaying user activity metrics
 */
export const UsersActivityCard = ({
    tenantApp
}: {
    tenantApp: TenantApp;
}): JSX.Element => {
    const { t } = useTranslation();

    return (
        <DataVisualCard title={t('Users.usersActivity')}>
            <Flex
                sx={{
                    alignItems: 'center',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center',
                    minHeight: '170px',
                    textAlign: 'center',
                    width: '100%'
                }}
            >
                {counts.map((item) => (
                    <Flex
                        key={item}
                        sx={{
                            alignItems: 'center',
                            gap: '16px',
                            justifyContent: 'center'
                        }}
                        width={['50%', '50%', '75%']}
                    >
                        <Flex
                            sx={{
                                flexWrap: 'wrap',
                                justifyContent: 'left'
                            }}
                            width="85%"
                        >
                            <Typography sx={{ fontSize: FontSizes[2] }}>
                                {t(`Users.${item}`)}
                            </Typography>
                        </Flex>
                        <Flex sx={{ justifyContent: 'right', width: '15%' }}>
                            <Typography
                                sx={{
                                    color: 'text.cardKPI',
                                    fontSize: FontSizes[2]
                                }}
                            >
                                {/* @ts-expect-error Don't know how to fix this */}
                                {tenantApp[item]}
                            </Typography>
                        </Flex>
                    </Flex>
                ))}
            </Flex>
        </DataVisualCard>
    );
};
